import { motion } from "framer-motion";
import { Camera } from "lucide-react";
import { images } from "../../data";

const shots = [
  { src: images.store1, label: "Reparto donna & bimbi", cls: "md:col-span-4 h-[420px] md:h-[560px]" },
  { src: images.store2, label: "Reparto uomo", cls: "md:col-span-4 h-[420px] md:h-[560px]" },
  { src: images.store3, label: "Dentro il negozio", cls: "md:col-span-4 h-[420px] md:h-[560px]" },
];

export default function Gallery() {
  return (
    <section
      id="galleria"
      data-testid="gallery-section"
      className="py-24 md:py-32 bg-[#FBEFF3] scroll-mt-24"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex items-center gap-3 mb-14">
          <Camera size={20} className="text-[#C24E77]" aria-hidden="true" />
          <div>
            <div className="text-xs tracking-[0.2em] uppercase text-[#C24E77]">
              Il negozio da fotografare
            </div>
            <h2 className="font-serif text-4xl md:text-5xl tracking-tight text-[#123D5B] mt-2">
              Uno sguardo <span className="italic text-[#C24E77]">dentro.</span>
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-6">
          {shots.map((s, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: (i % 3) * 0.08 }}
              className={`group relative rounded-2xl overflow-hidden border border-black/5 ${s.cls}`}
            >
              <img
                src={s.src}
                alt={s.label}
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#123D5B]/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-400" />
              <span className="absolute bottom-5 left-5 text-white font-serif text-xl opacity-0 translate-y-2 group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-400">
                {s.label}
              </span>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
